import React from 'react';
import PropTypes from 'prop-types';
import { childNodes } from 'Helpers/PropTypes';
import { FDBox, FDHeadlineText } from '@facet-wealth/design';

export default function HouseholdSection({ label, children }) {
  return (
    <FDBox paddingY={2}>
      <FDBox paddingY={2}>
        <FDHeadlineText value={label} />
      </FDBox>
      {children}
    </FDBox>
  );
}

HouseholdSection.propTypes = {
  label: PropTypes.string.isRequired,
  children: childNodes.isRequired,
};

HouseholdSection.defaultProps = {
};
